(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileMsTeamsFileInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "mimeIcons", "fileDao", "sideMenuManager", "modulesDao", "metaInfoConverter", "rolesManager", "$interval", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, mimeIcons, fileDao, sideMenuManager, modulesDao, metaInfoConverter, rolesManager, $interval) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/ms_teams_file/ms_teams-file-info').template('ms_teams-file-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                var updateTick = 30000;
                var restoreUpdateTickAfter;
                var updateWidget;
                function restartUpdating(promise, tick) {
                    if (promise) {
                        $interval.cancel(promise);
                    }
                    return $interval(function () {
                        $scope.loadData();
                    }, tick || 30000);
                }
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.loadData = function () {
                    return $q.allSettled([
                        fileDao.entityInfo('ms_teams_file', id),
                        mimeIcons()
                    ]).then(function (responses) {
                        var input = {};
                        input.originData = responses[0].value && responses[0].value.data || {};
                        // info logic
                        var icons = responses[1].value;
                        var msgIcon = icons(input.originData.mimetype_human || 'text/plain');
                        var fileName = input.originData.file_name;
                        $scope.model.info = $scope.model.info || {};
                        $scope.model.info.lines = $scope.model.info.lines || [
                            {
                                img: msgIcon,
                                class: 'profile-image'
                            },
                            {
                                text: fileName,
                                class: 'file-name'
                            }
                        ];
                        var queries = [modulesDao.entityInfo('ms_teams', 'ms_teams_file')];
                        var teamInfo, conversationInfo, userInfo;
                        if (input.originData && input.originData.team_id) {
                            queries.push(fileDao.entityInfo('ms_teams_team', input.originData.team_id));
                            teamInfo = queries.length - 1;
                        }
                        if (input.originData && input.originData.conversation_id) {
                            queries.push(fileDao.entityInfo('ms_teams_conversation', input.originData.conversation_id));
                            conversationInfo = queries.length - 1;
                        }
                        if (input.originData && input.originData.actor_id) {
                            queries.push(fileDao.entityInfo('ms_teams_user', input.originData.actor_id));
                            userInfo = queries.length - 1;
                        }
                        $q.allSettled(queries).then(function (respes) {
                            input.entityInfo = respes[0].value && respes[0].value.data || {};
                            input.resolvers = {
                                team_id: {},
                                conversation_id: {},
                                actor_id: {}
                            };
                            if (teamInfo) {
                                input.resolvers.team_id = respes[teamInfo].value && respes[teamInfo].value.data || {};
                            }
                            if (conversationInfo) {
                                input.resolvers.conversation_id = respes[conversationInfo].value && respes[conversationInfo].value.data || {};
                            }
                            if (userInfo) {
                                input.resolvers.actor_id = respes[userInfo].value && respes[userInfo].value.data || {};
                            }
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        'create_time',
                                        'mimetype_human',
                                        {
                                            key: 'team_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_team',
                                            resolverKey: 'name'
                                        },
                                        {
                                            key: 'conversation_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_conversation',
                                            resolverKey: 'name'
                                        },
                                        {
                                            key: 'actor_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_user',
                                            resolverKey: 'display_name'
                                        },
                                        'is_external',
                                        {
                                            key: 'is_deleted',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'content_url',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                            // actions
                            if ($scope.model.actionsWidget) {
                                $scope.model.actionsWidget.entityData = input.originData;
                            } else {
                                $scope.model.actionsWidget = {
                                    type: 'actions',
                                    logic: {
                                        name: 'remediationActionsLogic',
                                        updateTick: 30000,
                                        entityType: 'ms_teams_file',
                                        entityDataSlave: true
                                    },
                                    'class': 'file-info-actions-widget wide-250-buttons',
                                    wrapper: { type: 'none' },
                                    actions: rolesManager.isActionAllowed([
                                        'admin',
                                        'user',
                                        'operations'
                                    ]) ? [{
                                            autoId: 'profile_manual_action_btn_ms_teams_file_tombstone',
                                            actionType: 'ms_teams_file_tombstone',
                                            hiddenEntityAny: {
                                                is_deleted: true,
                                                is_tombstoned: true
                                            }
                                        }] : [],
                                    entityData: input.originData
                                };
                            }
                        });
                        if (restoreUpdateTickAfter && restoreUpdateTickAfter.isBefore(moment())) {
                            restoreUpdateTickAfter = null;
                            updateWidget = restartUpdating(updateWidget, updateTick);
                        }
                    }, function (err) {
                        console.log('Error in ms_teams file info:', err);
                    });
                };
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                updateWidget = $interval(function () {
                    $scope.loadData();
                }, updateTick);
                widgetPolling.on('remediationActionPerformed', function () {
                    restoreUpdateTickAfter = moment().add(30, 'seconds');
                    updateWidget = restartUpdating(updateWidget, 3000);
                });
                $scope.$on('$locationChangeStart', function () {
                    if (updateWidget) {
                        $interval.cancel(updateWidget);
                    }
                });
            }
        };
    }]);
}());